/**
 * Generated by orval 🍺
 * Do not edit manually.
 * SolidOps API
 * OpenAPI spec version: 1.0.0
 */
import * as zod from 'zod';

export const scheduleDetailResponseOutputIdRegExp = new RegExp(
  '^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$',
);
export const scheduleDetailResponseOutputTeamIdRegExp = new RegExp(
  '^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$',
);
export const scheduleDetailResponseOutputTimeZoneMax = 100;

export const scheduleDetailResponseOutputVersionExclusiveMin = 0;
export const scheduleDetailResponseOutputVersionMax = 9007199254740991;

export const scheduleDetailResponseOutputCreatedAtRegExp = new RegExp(
  '^(?:(?:\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\\d|30)|(?:02)-(?:0[1-9]|1\\d|2[0-8])))T(?:(?:[01]\\d|2[0-3]):[0-5]\\d:[0-5]\\d(?:\\.\\d+)?(?:Z|([+-](?:[01]\\d|2[0-3]):[0-5]\\d)))$',
);
export const scheduleDetailResponseOutputArchivedAtOneRegExp = new RegExp(
  '^(?:(?:\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\\d|30)|(?:02)-(?:0[1-9]|1\\d|2[0-8])))T(?:(?:[01]\\d|2[0-3]):[0-5]\\d:[0-5]\\d(?:\\.\\d+)?(?:Z|([+-](?:[01]\\d|2[0-3]):[0-5]\\d)))$',
);
export const scheduleDetailResponseOutputRoutinesItemStartLocalDateRegExp = new RegExp(
  '^(?:(?:\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\\d|30)|(?:02)-(?:0[1-9]|1\\d|2[0-8])))$',
);
export const scheduleDetailResponseOutputRoutinesItemAnchorClockLocalRegExp = new RegExp(
  '^(?:[01]\\d|2[0-3]):[0-5]\\d$',
);
export const scheduleDetailResponseOutputRoutinesItemRotationCountExclusiveMin = 0;
export const scheduleDetailResponseOutputRoutinesItemRotationCountMax = 2147483647;

export const scheduleDetailResponseOutputRoutinesItemSectionsItemStartWeekdayMax = 7;

export const scheduleDetailResponseOutputRoutinesItemSectionsItemStartLocalMinuteMin = 0;
export const scheduleDetailResponseOutputRoutinesItemSectionsItemStartLocalMinuteMax = 1439;

export const scheduleDetailResponseOutputRoutinesItemSectionsItemEndWeekdayMax = 7;

export const scheduleDetailResponseOutputRoutinesItemSectionsItemEndLocalMinuteMin = 0;
export const scheduleDetailResponseOutputRoutinesItemSectionsItemEndLocalMinuteMax = 1439;

export const scheduleDetailResponseOutputRoutinesItemSectionsItemFullWeekDefault = false;
export const scheduleDetailResponseOutputRoutinesItemSectionsMax = 14;

export const scheduleDetailResponseOutputRoutinesItemParticipantsItemOrdinalMin = 0;
export const scheduleDetailResponseOutputRoutinesItemParticipantsItemOrdinalMax = 19;

export const scheduleDetailResponseOutputRoutinesItemParticipantsItemUserIdRegExp = new RegExp(
  '^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$',
);
export const scheduleDetailResponseOutputRoutinesItemParticipantsMax = 20;

export const scheduleDetailResponseOutputRoutinesItemEndedAtOneRegExp = new RegExp(
  '^(?:(?:\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\\d|30)|(?:02)-(?:0[1-9]|1\\d|2[0-8])))T(?:(?:[01]\\d|2[0-3]):[0-5]\\d:[0-5]\\d(?:\\.\\d+)?(?:Z|([+-](?:[01]\\d|2[0-3]):[0-5]\\d)))$',
);
export const scheduleDetailResponseOutputRoutinesItemIdRegExp = new RegExp(
  '^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$',
);
export const scheduleDetailResponseOutputRoutinesItemScheduleIdRegExp = new RegExp(
  '^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$',
);
export const scheduleDetailResponseOutputRoutinesItemVersionExclusiveMin = 0;
export const scheduleDetailResponseOutputRoutinesItemVersionMax = 9007199254740991;

export const scheduleDetailResponseOutputRoutinesItemRoutineVersionIdRegExp = new RegExp(
  '^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$',
);
export const scheduleDetailResponseOutputRoutinesItemCreatedAtRegExp = new RegExp(
  '^(?:(?:\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\\d|30)|(?:02)-(?:0[1-9]|1\\d|2[0-8])))T(?:(?:[01]\\d|2[0-3]):[0-5]\\d:[0-5]\\d(?:\\.\\d+)?(?:Z|([+-](?:[01]\\d|2[0-3]):[0-5]\\d)))$',
);
export const scheduleDetailResponseOutputRoutinesItemPendingChangesItemVersionIdRegExp = new RegExp(
  '^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$',
);
export const scheduleDetailResponseOutputRoutinesItemPendingChangesItemActivatesAtRegExp =
  new RegExp(
    '^(?:(?:\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\\d|30)|(?:02)-(?:0[1-9]|1\\d|2[0-8])))T(?:(?:[01]\\d|2[0-3]):[0-5]\\d:[0-5]\\d(?:\\.\\d+)?(?:Z|([+-](?:[01]\\d|2[0-3]):[0-5]\\d)))$',
  );
export const scheduleDetailResponseOutputRoutinesItemPendingChangesItemSavedAtRegExp = new RegExp(
  '^(?:(?:\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\\d|30)|(?:02)-(?:0[1-9]|1\\d|2[0-8])))T(?:(?:[01]\\d|2[0-3]):[0-5]\\d:[0-5]\\d(?:\\.\\d+)?(?:Z|([+-](?:[01]\\d|2[0-3]):[0-5]\\d)))$',
);
export const scheduleDetailResponseOutputRoutinesItemPendingChangesItemEffectiveLocalDateRegExp =
  new RegExp(
    '^(?:(?:\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\\d|30)|(?:02)-(?:0[1-9]|1\\d|2[0-8])))$',
  );
export const scheduleDetailResponseOutputRoutinesItemPendingChangesMax = 2;

export const scheduleDetailResponseOutputRoutinesMax = 10;

export const ScheduleDetailResponseOutput = zod.object({
  id: zod.uuid().regex(scheduleDetailResponseOutputIdRegExp),
  teamId: zod.uuid().regex(scheduleDetailResponseOutputTeamIdRegExp),
  name: zod.unknown().and(zod.unknown()),
  timeZone: zod.string().min(1).max(scheduleDetailResponseOutputTimeZoneMax),
  state: zod.enum(['active', 'archived']),
  version: zod
    .int()
    .gt(scheduleDetailResponseOutputVersionExclusiveMin)
    .max(scheduleDetailResponseOutputVersionMax),
  createdAt: zod.iso.datetime({ offset: true }).regex(scheduleDetailResponseOutputCreatedAtRegExp),
  archivedAt: zod.union([
    zod.iso.datetime({ offset: true }).regex(scheduleDetailResponseOutputArchivedAtOneRegExp),
    zod.null(),
  ]),
  routines: zod
    .array(
      zod.object({
        name: zod.unknown().and(zod.unknown()),
        startLocalDate: zod.iso
          .date()
          .regex(scheduleDetailResponseOutputRoutinesItemStartLocalDateRegExp),
        anchorClockLocal: zod
          .string()
          .regex(scheduleDetailResponseOutputRoutinesItemAnchorClockLocalRegExp),
        rotation: zod.object({
          unit: zod.enum(['day', 'week']),
          count: zod
            .int()
            .gt(scheduleDetailResponseOutputRoutinesItemRotationCountExclusiveMin)
            .max(scheduleDetailResponseOutputRoutinesItemRotationCountMax),
        }),
        sections: zod
          .array(
            zod.object({
              startWeekday: zod
                .int()
                .min(1)
                .max(scheduleDetailResponseOutputRoutinesItemSectionsItemStartWeekdayMax),
              startLocalMinute: zod
                .int()
                .min(scheduleDetailResponseOutputRoutinesItemSectionsItemStartLocalMinuteMin)
                .max(scheduleDetailResponseOutputRoutinesItemSectionsItemStartLocalMinuteMax),
              endWeekday: zod
                .int()
                .min(1)
                .max(scheduleDetailResponseOutputRoutinesItemSectionsItemEndWeekdayMax),
              endLocalMinute: zod
                .int()
                .min(scheduleDetailResponseOutputRoutinesItemSectionsItemEndLocalMinuteMin)
                .max(scheduleDetailResponseOutputRoutinesItemSectionsItemEndLocalMinuteMax),
              fullWeek: zod
                .boolean()
                .default(scheduleDetailResponseOutputRoutinesItemSectionsItemFullWeekDefault),
            }),
          )
          .min(1)
          .max(scheduleDetailResponseOutputRoutinesItemSectionsMax),
        participants: zod
          .array(
            zod.object({
              ordinal: zod
                .int()
                .min(scheduleDetailResponseOutputRoutinesItemParticipantsItemOrdinalMin)
                .max(scheduleDetailResponseOutputRoutinesItemParticipantsItemOrdinalMax),
              userId: zod
                .uuid()
                .regex(scheduleDetailResponseOutputRoutinesItemParticipantsItemUserIdRegExp),
            }),
          )
          .min(1)
          .max(scheduleDetailResponseOutputRoutinesItemParticipantsMax),
        endedAt: zod
          .union([
            zod.iso
              .datetime({ offset: true })
              .regex(scheduleDetailResponseOutputRoutinesItemEndedAtOneRegExp),
            zod.null(),
          ])
          .optional(),
        id: zod.uuid().regex(scheduleDetailResponseOutputRoutinesItemIdRegExp),
        scheduleId: zod.uuid().regex(scheduleDetailResponseOutputRoutinesItemScheduleIdRegExp),
        version: zod
          .int()
          .gt(scheduleDetailResponseOutputRoutinesItemVersionExclusiveMin)
          .max(scheduleDetailResponseOutputRoutinesItemVersionMax),
        routineVersionId: zod
          .uuid()
          .regex(scheduleDetailResponseOutputRoutinesItemRoutineVersionIdRegExp),
        createdAt: zod.iso
          .datetime({ offset: true })
          .regex(scheduleDetailResponseOutputRoutinesItemCreatedAtRegExp),
        pendingChanges: zod
          .array(
            zod.object({
              kind: zod.enum(['sections', 'rotation']),
              versionId: zod
                .uuid()
                .regex(scheduleDetailResponseOutputRoutinesItemPendingChangesItemVersionIdRegExp),
              activatesAt: zod.iso
                .datetime({ offset: true })
                .regex(scheduleDetailResponseOutputRoutinesItemPendingChangesItemActivatesAtRegExp),
              savedAt: zod.iso
                .datetime({ offset: true })
                .regex(scheduleDetailResponseOutputRoutinesItemPendingChangesItemSavedAtRegExp),
              effectiveLocalDate: zod.iso
                .date()
                .regex(
                  scheduleDetailResponseOutputRoutinesItemPendingChangesItemEffectiveLocalDateRegExp,
                )
                .optional(),
            }),
          )
          .max(scheduleDetailResponseOutputRoutinesItemPendingChangesMax),
      }),
    )
    .max(scheduleDetailResponseOutputRoutinesMax),
});

export type ScheduleDetailResponseOutput = zod.input<typeof ScheduleDetailResponseOutput>;
export type ScheduleDetailResponseOutputOutput = zod.output<typeof ScheduleDetailResponseOutput>;
